// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3BYQG","title":"AfterBackImages_title__38Q4l","images":"AfterBackImages_images__sNiEL"};